<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>评论管理</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 搜索筛选 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-input size="small" v-model="keyword" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-input size="small" v-model="content" placeholder="请输入评价内容"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 列表 -->
        <el-table size="small" :data="revData" element-loading-text="拼命加载中" style="width: 90%;" border>
            <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
            <!-- <el-table-column align="center" sortable prop="id" label="编号" width="70px"></el-table-column> -->
            <el-table-column align="center" sortable prop="name" label="用户名"></el-table-column>
            <el-table-column align="center" prop="avatar" label="头像">
                <template slot-scope="scope">
                    <el-image v-if="scope.row.avatar" style="width: 40px;height: 40px;" :src="scope.row.avatar"
                        :preview-src-list="[scope.row.avatar]" />
                    <div v-if="scope.row.avatar == null">没有图片</div>
                </template>
            </el-table-column>
            <el-table-column align="center" sortable prop="mobile" label="手机号"></el-table-column>
            <el-table-column align="center" sortable prop="publishName" label="评论来源"></el-table-column>
            <el-table-column align="center" sortable prop="content" label="评论内容"></el-table-column>
            <el-table-column align="center" sortable prop="createTime" label="创建时间">
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="deleRev(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    </div>
</template>

<script>
import { getPublishReplyList } from '../../api/userMG'
import { deletePublishReplyList } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
    data() {
        return {
            keyword: '',
            content: '',

            // 用户数据
            revData: [],

            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            }
        }

    },
    // 注册组件
    components: {
        Pagination
    },
    created() {
        this.getdata(1)
    },
    methods: {
        // 分页插件事件
        callFather(parm) {
            this.pageparm.page = parm.currentPage
            this.getdata(parm.currentPage)
        },
        //搜索数据
        search() {
            this.getdata(1)
        },
        // 重置数据
        chongzhi() {
            this.keyword = ''
            this.content = ''
            this.getdata(1)
        },
        // 删除按钮
        deleRev(row) {
            this.$confirm('确定要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let data = {
                    id: row.id
                }
                deletePublishReplyList(data).then(res => {
                    console.log(",,,,,", res)
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        this.getdata(1);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },

        // 获取数据
        getdata(page) {
            this.editFormVisible = false;
            this.loading = true;
            // 获取评论列表
            var parameter = {
                type: -1,
                page: (page - 1) * 20,
                mobile: this.keyword,
                content: this.content
            };
            getPublishReplyList(parameter).then((res) => {
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg,
                    });
                } else {
                    this.revData = res.data.list;
                    this.pageparm.currentPage = page;
                    this.pageparm.total = res.data.count;
                    return;
                }
            })

        }
    }


}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/terrace/Review.vue